module.exports = __webpack_public_path__ + "city-16438a9af318fde155e2c93be599fdbc.svg";